module.exports = __webpack_public_path__ + "static/media/README.9b971c57.md";